import type { Config, ClientOptions } from "./client";

/**
 * Runtime config for the API client. Used by the generated client.gen.ts.
 * Supports Expo (EXPO_PUBLIC_API_URL) and Vite web (VITE_API_URL),
 * with localhost as the final fallback.
 */
const getViteApiUrl = (): string | undefined => {
  try {
    return new Function(
      'return typeof import.meta !== "undefined" ? import.meta.env?.VITE_API_URL : undefined;',
    )() as string | undefined;
  } catch {
    return undefined;
  }
};

const getProcessEnv = (): Record<string, string | undefined> | undefined => {
  const processCandidate = (globalThis as { process?: { env?: unknown } })
    .process;
  if (!processCandidate || typeof processCandidate !== "object")
    return undefined;
  const env = processCandidate.env;
  if (!env || typeof env !== "object") return undefined;
  return env as Record<string, string | undefined>;
};

export const createClientConfig = (
  override?: Config<ClientOptions>,
): Config<Required<ClientOptions>> => {
  const processEnv = getProcessEnv();
  return {
    // Access process env safely for runtimes where `process` is undefined (e.g. browsers).
    baseURL:
      processEnv?.EXPO_PUBLIC_API_URL ||
      processEnv?.VITE_API_URL ||
      getViteApiUrl() ||
      "http://localhost:8000",
    ...override,
  };
};
